module.exports = __webpack_public_path__ + "img/process@2x.ffa6c832.jpg";